import { SVGProps } from "react";

export default function UnlinkIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 12, width = 12, ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.25 7.375H5C4.795 7.375 4.625 7.205 4.625 7C4.625 6.795 4.795 6.625 5 6.625H6.25C7.56 6.625 8.625 5.56 8.625 4.25C8.625 2.94 7.56 1.875 6.25 1.875H3.75C2.44 1.875 1.375 2.94 1.375 4.25C1.375 4.8 1.57 5.335 1.92 5.76C2.05 5.92 2.03 6.155 1.87 6.29C1.71 6.42 1.475 6.4 1.34 6.24C0.88 5.68 0.625 4.975 0.625 4.25C0.625 2.525 2.025 1.125 3.75 1.125H6.25C7.975 1.125 9.375 2.525 9.375 4.25C9.375 5.975 7.975 7.375 6.25 7.375Z"
        fill="#166C3B"
      />
      <path
        d="M8.25 10.875H5.75C4.025 10.875 2.625 9.475 2.625 7.75C2.625 6.025 4.025 4.625 5.75 4.625H7C7.205 4.625 7.375 4.795 7.375 5C7.375 5.205 7.205 5.375 7 5.375H5.75C4.44 5.375 3.375 6.44 3.375 7.75C3.375 9.06 4.44 10.125 5.75 10.125H8.25C9.56 10.125 10.625 9.06 10.625 7.75C10.625 7.2 10.43 6.665 10.08 6.24C9.95 6.08 9.97 5.845 10.13 5.71C10.29 5.575 10.525 5.6 10.66 5.76C11.125 6.32 11.38 7.025 11.38 7.75C11.375 9.475 9.975 10.875 8.25 10.875Z"
        fill="#292D32"
      />
    </svg>
  );
}
